import { render, staticRenderFns } from "./ModalPreview.vue?vue&type=template&id=6231c3a4&scoped=true"
import script from "./ModalPreview.vue?vue&type=script&lang=js"
export * from "./ModalPreview.vue?vue&type=script&lang=js"
import style0 from "./ModalPreview.vue?vue&type=style&index=0&id=6231c3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6231c3a4",
  null
  
)

export default component.exports